import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import UserEdit from '@/ui/pages/UserEdit/UserEdit';

export const Route = createFileRoute('/_dashboard/users/new/$tenantId')({
  beforeLoad: requireRoute('/users/new/$tenantId'),
  component: UserEdit,
});
